export const CombineUnique = <T>(arrays: T[][]) => [...new Set<T>(new Array().concat(...arrays))];
export const CombineUniqueObjects = <T>(array1: T[], array2: T[], identifier: keyof T) => {
  const map = new Map();
  [...array1, ...array2].forEach((data) => map.set(data[identifier], data));
  return [...map.values()];
};
